module.exports = __webpack_public_path__ + "img/00028.2472eae9.webp";